export const LOCAL_STORAGE_KEYS = [
  // User session
  'queryParams',
  'rentspreeSubscriptions',
  'rentspreeUserTokenTemp',
  'rentspreeTempUser',
  /*
   * Agent dashboard application,
   * rcm
   */
  'contact_detail_collapse_state',
  // rcm
  'contact_dont_show_redirect_countdown',
  // share report landlord reminder
  'share_prompt_property_skip_list',
  // rent payment
  'rp.overridePayeeIdvUntilTimestamp',
  // rent payment
  'rp.defaultFeeCollection',
  // rent payment
  'drafting_for_landlord',
  // announcement
  'notifyListingSyndication',
  // announcement
  'notifyCollectRent',
]

// TODO: Set standard for local storage with prefix key,
// implement clear all prefix local storage in a library
export const removeAllLocalStorageItems = () => {
  LOCAL_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key)
  })
}
